/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembershipPurchaseResponse } from '../../models/membership-purchase-response';

export interface SaveStripeMembershipsPurchaseSessionDetailsSuccess$Params {
  stripeSessionId: string;
}

export function saveStripeMembershipsPurchaseSessionDetailsSuccess(http: HttpClient, rootUrl: string, params: SaveStripeMembershipsPurchaseSessionDetailsSuccess$Params, context?: HttpContext): Observable<StrictHttpResponse<MembershipPurchaseResponse>> {
  const rb = new RequestBuilder(rootUrl, saveStripeMembershipsPurchaseSessionDetailsSuccess.PATH, 'post');
  if (params) {
    rb.query('stripeSessionId', params.stripeSessionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MembershipPurchaseResponse>;
    })
  );
}

saveStripeMembershipsPurchaseSessionDetailsSuccess.PATH = '/api/memberships/save-stripe-memberships-purchase-session-details-success';
